import { Attr } from '@vuex-orm/core'

export default class OptionalAttr extends Attr { 
    toString(name) {
        return name 
    }
}